import { render, staticRenderFns } from "./offerlistorder.vue?vue&type=template&id=dd98c512"
import script from "./offerlistorder.vue?vue&type=script&lang=js"
export * from "./offerlistorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports